module.exports = {"version":"3.1.5"}


//////////////////
// WEBPACK FOOTER
// ./version.json
// module id = 384
// module chunks = 1